import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";

import {
  changeAppointmentData,
  GetUpcomingAppointment,
  GetPastAppt,
  getProviderAvailablity,
  addAppointment,
} from "../../StateManagement/Reducers/AppointmentsState";

import PastAppointment from "./PastAppointment";
import TopNav from "../TopNav";
import AddAppointment from "./AddAppointment";
import UpcomingAppointments from "./UpcomingAppointments";
import MessageModal from "./AddAppointment/MessageModal";
import Loading from "../StyledComponents/Loading";
import { ModalDailog, ModalBody } from "./AddAppointment/StyledComponents";
import AddAppointmentFormModal from "./AddAppointment/AddAppointmentFormModal";

import { Div, BodyContainer, PastApptBodycont } from "../StyledComponents";
import {
  getPatientTimezone,
  getShowPatientCurrentTime,
} from "../utils/RepeatFunctions/Timezone.js"



const Appointment = () => {
  // ------------------------------ State and Variables Start--------------------------------------------------- //


  const dispatch = useDispatch();
  // const params = useParams();
  const [activeTab, setActiveTab] = useState("upcoming");
  const [showAddModal, setShowAddModal] = useState(false);

  const appointmentData = useSelector(
    (state) => state.Appointments.appointmentData,
  );
  const addLoader = useSelector((state) => state.Appointments.loadingSave);
  const upLoader = useSelector((state) => state.Appointments.loadCounter);
  const pastLoader = useSelector((state) => state.Appointments.pastApptLoading);
  const refresh = useSelector((state) => state.Dashboard.RefreshAppt);

  const handleCloseModal = () => {
    setShowAddModal(false);
    dispatch(changeAppointmentData({ name: "changeUrl", value: "" }));
  };

  // ------------------------------ State and Variables End--------------------------------------------------- //

  // useEffect(() => {
  //   dispatch(GetUpcomingAppointment("show"));
  // }, [refresh, params.selector]);
  useEffect(() => {
    dispatch(GetUpcomingAppointment("show"));
  }, [refresh]);

  // useEffect(() => {
  //   dispatch(GetPastAppt());
  // }, [params.selector]);

  useEffect(() => {
    dispatch(GetPastAppt());
  }, []);

  useEffect(() => {
    if (appointmentData["showMessage"]) {
      setTimeout(() => {
        handleCloseModal();
      }, 50);
    }
  }, [appointmentData["showMessage"]]);

  const providersList = useSelector(
    (state) => state.Appointments.providersList
  );

  useEffect(() => {
    if (
      appointmentData["provider"] &&
      appointmentData["office"] &&
      appointmentData["aptdate"]
    ) {
      const providerObj = providersList?.find(
        (p) => Number(p.id) === Number(appointmentData["provider"])
      );
      const providerTimezone = providerObj?.timezone || null;
      const patientTimezone = getPatientTimezone();

      dispatch(
        getProviderAvailablity({
          provider_id: appointmentData["provider"],
          facility_id: appointmentData["office"],
          date: appointmentData["aptdate"],
          patient_timezone: patientTimezone,
          provider_timezone: providerTimezone,
        }),
      );
    }
  }, [
    dispatch,
    appointmentData["provider"],
    appointmentData["aptdate"],
    appointmentData["office"],
    providersList,
  ]);

  return (
    <Div background="#F3F4F6" height="100%">
      <TopNav
        title="Appointment List"
        // TitleDescription="Manage Your Appointment"
      />
      {addLoader || upLoader || pastLoader ? (
        <Loading />
      ) : (
        // <PastApptBodycont display="flex" height="calc(100% - 111px)">
        //   <Div width="calc(37% + 1px)" height="100%">
        //     <UpcomingAppointments />
        //   </Div>

        //   <Div height="100%" width="63%">
        //     {params.selector === "add_appointment" ? (
        //       <AddAppointment />
        //     ) : (
        //       <PastAppointment />
        //     )}
        //   </Div>
        // </PastApptBodycont><Div padding="0 24px">
        <Div padding="0" width="100%" height="calc(100% - 111px)">
          <Div
            display="flex"
            borderBottom="1px solid #E5E7EB"
            background="#F3F4F6"
          >
            <Div
              padding="14px 20px"
              cursor="pointer"
              background="#F3F4F6"
              borderBottom={
                activeTab === "upcoming" ? "2px solid #2C7BE5" : "none"
              }
              fontWeight={activeTab === "upcoming" ? "600" : "400"}
              onClick={() => setActiveTab("upcoming")}
            >
              Upcoming Appointments
            </Div>

            <Div
              padding="14px 20px"
              cursor="pointer"
              borderBottom={activeTab === "past" ? "2px solid #2C7BE5" : "none"}
              fontWeight={activeTab === "past" ? "600" : "400"}
              onClick={() => setActiveTab("past")}
              background="#F3F4F6"
            >
              Past Appointments
            </Div>
          </Div>
          <Div height="calc(100% - 60px)" background="#F3F4F6">
            {activeTab === "upcoming" && (
              <UpcomingAppointments
                key="upcoming"
                onScheduleClick={() => setShowAddModal(true)}
              />
            )}

            {activeTab === "past" && (
              <PastAppointment
                key="past"
                onScheduleClick={() => setShowAddModal(true)}
              />
            )}
          </Div>
        </Div>
      )}

      <MessageModal
        active={appointmentData["showMessage"]}
        color={appointmentData["messageType"]}
        onHide={() =>
          dispatch(changeAppointmentData({ name: "showMessage", value: false }))
        }
      />
      {console.log("SHOW MODAL:", showAddModal)}
      {showAddModal &&
        ReactDOM.createPortal(
          <ModalDailog>
            <ModalBody>
              <AddAppointmentFormModal onClose={handleCloseModal} />
            </ModalBody>
          </ModalDailog>,
          document.body,
        )}
    </Div>
  );
};

export default Appointment;
